// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"407":"292f77b1","586":"42317091","696":"a071d7b8"}[chunkId] + ".js";
};